
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'
class Welcome1 extends React.Component {
  constructor(props) {
    super(props)
  }

  next() {
    const { next, addHowlSound } = this.props
    next()
    addHowlSound('button_click_icon')
  }

  render() {
    return (
      <div className="container background background--mars">
        <div className="content">
          <div className="mars--welcome">
            <div className="mars--init__title">
              <FormattedMessage id="welcome.text1" />
            </div>
            <div className="mars--welcome__message">
              <p className="text">
                <FormattedMessage id="welcome.text2" />
              </p>
              <p className="text">
                <FormattedMessage id="welcome.text3" />
              </p>
              <p className="text">
                <FormattedMessage id="welcome.text4" />
              </p>
            </div>
            <div
              onClick={() => {
                this.next()
              }}
              className="btn--orange"
            >
              <span className="icon-rocket"></span>
              <span>
                <FormattedMessage id={'phase.begin'} />
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Welcome1.propTypes = {
  next: PropTypes.func,
  addHowlSound: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}

export default connect(null, mapDispatchToProps)(injectIntl(Welcome1))
